const getVisibleCabinsAndSelectedCabinCode = ({
	cabins,
	cabinFallback,
	isListingOrQuote,
	requestedCabinCode,
}) => {
	const isFallbackActive = isListingOrQuote && Boolean(cabinFallback);

	if (!isFallbackActive) {
		return { visibleCabins: cabins, selectedCabinCode: requestedCabinCode };
	}

	const visibleCabins = cabins.filter(({ code }) => code !== cabinFallback.cabinRequested);
	const selectedCabinCode =
		requestedCabinCode === cabinFallback.cabinRequested
			? cabinFallback.cabinReturned
			: requestedCabinCode;

	return { visibleCabins, selectedCabinCode };
};

export default getVisibleCabinsAndSelectedCabinCode;
